import { useEffect, useState } from "react"
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { useAuth } from "../contexts/auth";
import { IUserInformation } from "../interfaces/IUser";
import { GetDepartmentsByUserID } from "../services/department";
import { getUsers, getUsersByProyectoID } from "../services/user";


export const useListUsersByUser = () => {

    // States
    const { user } = useAuth();
    const [listUser, setListUser] = useState<IUserInformation[]>([]);
    const [loadingUser, setLoadingUser] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetUsers();
    }, [user])

    // Handles
    const handleGetUsers = () => {
        setLoadingUser(true)
        tryCatch(() => {
            getUsers(user?.usuarioID!)
                .then((response) => {
                    setListUser(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingUser(false));
        })
    }

    return {
        listUser,
        loadingUser
    }
}

export const useListUsers = () => {

    // States
    const { user } = useAuth();
    const [listUserAll, setListUserAll] = useState<IUserInformation[]>([]);
    const [loadingUserAll, setLoadingUserAll ] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetUsers();
    }, [user])

    // Handles
    const handleGetUsers = () => {
        setLoadingUserAll(true)
        tryCatch(() => {
            getUsersByProyectoID()
                .then((response) => {
                    setListUserAll(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingUserAll(false));
        })
    }

    return {
        listUserAll,
        loadingUserAll
    }
}